<template>
    <div class="row justify-content-center">

        <EmailLogin/>

        <div class="col-12"></div>

        <div class="row mt-1 justify-content-center">
            <SocialLogin/>
        </div>
        <div class="col-12"></div>
        <div class="row mt-3">
            <div class="col-12 text-center other-login">
                <router-link :to="recoveryLink()" class="text-light">
                    {{ $t('forgot_password') }}
                </router-link>
            </div>
            <div class="col-12 text-center mt-2 other-login">
                <router-link to="/user/signin" class="text-light">
                    {{ $t('do_register') }}
                </router-link>
            </div>
        </div>
    </div>
</template>
<script>
    import SocialLogin from "./SocialLogin";
    import EmailLogin from "./Auth/EmailLogin";

    export default {
        name: 'user-login',
        components: {EmailLogin, SocialLogin},
        data() {
            return {}
        },
        mounted() {
        },
        methods: {
            recoveryLink() {
                if ('return' in this.$route.query) return '/user/recovery?return=' + this.$route.query.return
                return '/user/recovery'
            }
        }
    }
</script>
